<script lang="ts">
    import { Button, ButtonGroup, Icon } from "sveltestrap";
    import type { Third } from '../Model/Third';
    import { createEventDispatcher } from "svelte";
    import { pedestrianService } from "../services";

    export let thirds: Third[];

    const dispatch = createEventDispatcher();

    function onThirdClick(third: Third){
        dispatch('editThird', third)
    }

    function onAddNewThird(){
        dispatch('newThird')
    }

    async function deleteThird(id) {
        dispatch('deleteComplainant', id);
    }

</script>

<style>

</style>

<div class="row">
    <div class="col-8">
        <h5>Listado</h5>
    </div>
    <div class="col-4 text-end">
        <button class="btn btn-primary" type="button" id="denouncedThirId" name="denouncedThirId" on:click={() => {onAddNewThird();}}>
            <Icon name="plus" /> <span class="mobile-view">Añadir</span> 
        </button>
    </div>
  <div class="col-12">
    {#if thirds?.length}
        <div class="table-responsive">
            <table class="table" >
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Apellidos</th>
                        <th scope="col">Identificación</th>
                        <th> </th>
                    </tr>
                </thead>
                <tbody>
                    {#each thirds as third, index }
                        <tr>
                            <th scope="row">{index + 1}</th>
                            <td><span class="btn btn-link p-0" on:click={() => {
                                onThirdClick(third);
                            }}>{third.name}</span></td>
                            <td>{third.surname1} {third.surname2}</td>
                            <td>{third.document}</td>
                            <td class="text-end">
                                <ButtonGroup>
                                    <Button color="danger" on:click={() => deleteThird(third.id)}><Icon name="x" /></Button>
                                </ButtonGroup>
                            </td>
                        </tr>
                    {/each}
                </tbody>
            </table>
        </div>
    {:else}
        <div class="text-center pt-2">
            <h5>No hay Terceros para mostrar</h5>
        </div>
    {/if}
  </div>
</div>
